<h2 mat-dialog-title>About Completion</h2>
<mat-dialog-content>
  <div class="about-content" *ngIf="versionInfo">
    <div class="about-logo">
      <img src="assets/img/aker-solutions-logo.png" alt="Aker Solutions" height="40" />
    </div>

    <table class="about-table">
      <tr>
        <td class="label">Version</td>
        <td class="value">{{ versionInfo.version }}</td>
      </tr>
      <tr>
        <td class="label">Build</td>
        <td class="value"><code>{{ versionInfo.hash }}</code></td>
      </tr>
      <tr *ngIf="versionInfo.branch">
        <td class="label">Branch</td>
        <td class="value">{{ versionInfo.branch }}</td>
      </tr>
      <tr *ngIf="versionInfo.buildTimestamp">
        <td class="label">Built</td>
        <td class="value">{{ versionInfo.buildTimestamp | date: 'medium' }}</td>
      </tr>
    </table>
  </div>

  <div *ngIf="!versionInfo" class="about-loading">
    <p>Loading version info…</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
